export default "https://assets-v2.scaler.com/packs/images/officeBag.147e89.svg";